import { type } from '../../../constants/QBActionsConst'

const GetOptions = (options, user) => {
    let ans = []

    if (!user) return ans

    for (let index = 0; index < options.length; index++) {
        let ok = true
        let option = options[index]

        if (option.allow.includes(type.ONLY_SUPER_ADMIN)) {
            if (user.tier_id && user.tier_id === 100) {
                ok = false
                ans.push(option);
            }
        }

        if (option.allow.includes(type.ALL)) {
            ans.push(option)
            continue;
        }

        let auth = false
        let actions = user.actions ? user.actions : []
        for (let indexA = 0; indexA <= actions.length; indexA++) {
            let action = actions[indexA]
            if (option.allow.includes(action)) {
                auth = true;
                break;
            }
        }

        if (auth && ok) {
            let newOption = option

            // check permission submenu
            if (Array.isArray(option.children)) {
                let newChildrens = []

                let childrens = option.children

                for (let i = 0; i < childrens.length; i++) {
                    let children = childrens[i]

                    if (children.allow.includes(type.ONLY_SUPER_ADMIN)) {
                        if (user.tier_id && user.tier_id === 100) {
                            newChildrens.push(children);
                            continue
                        }
                    }

                    if (children.allow.includes(type.ALL)) {
                        newChildrens.push(children)
                        continue;
                    }

                    let authChild = false
                    let actions = user.actions ? user.actions : []
                    for (let indexA = 0; indexA <= actions.length; indexA++) {
                        let action = actions[indexA]
                        if (children.allow.includes(action)) {
                            authChild = true;
                            break;
                        }
                    }

                    if (authChild) 
                        newChildrens.push(children)

                }

                // update newOption
                newOption = {
                    ...newOption,
                    ...{
                        children: newChildrens
                    }
                }
            }

            ans.push(newOption)
        }
    }

    return ans
}

export default GetOptions